export default {
  updateEmail: {
      snackbarMessage: {
      success: 'Ya guardamos tus cambios',
    }
  },
}
